import { useEffect } from "react";
import { useProjects, useRuns } from "../../lib/queries";
import { useCockpit } from "../../lib/state";
import ProjectRow from "./ProjectRow";
import ServicesMini from "./ServicesMini";
import ApprovalsQueue from "./ApprovalsQueue";
import PrioritiesQueue from "./PrioritiesQueue";
import TodayRailPane from "../panes/TodayRailPane";

export default function LeftRail() {
  const { data: projects = [] } = useProjects();
  const { data: runs = [] } = useRuns();
  const selectedId = useCockpit((s) => s.selectedProjectId);
  const setSelected = useCockpit((s) => s.setSelectedProjectId);

  useEffect(() => {
    if (selectedId || projects.length === 0) return;
    const fromHash = window.location.hash.replace(/^#\//, "");
    const match = projects.find((p) => p.id === fromHash);
    setSelected(match?.id ?? projects[0].id);
  }, [projects, selectedId, setSelected]);

  useEffect(() => {
    const handler = () => {
      const id = window.location.hash.replace(/^#\//, "");
      if (id) setSelected(id);
    };
    window.addEventListener("hashchange", handler);
    return () => window.removeEventListener("hashchange", handler);
  }, [setSelected]);

  const activeProjectIds = new Set(
    runs
      .filter((r) => r.status === "pending" || r.status === "running")
      .map((r) => r.project),
  );

  return (
    <aside
      className="aero-glass mx-3 my-3 flex shrink-0 flex-col overflow-y-auto px-2 py-3"
      style={{ width: 248, borderRadius: 24 }}
    >
      {/* Projects FIRST — this is the primary navigation. Anything else
          ahead of it pushes the list below the fold on shorter windows. */}
      <div className="flex items-center justify-between px-2 pt-1 pb-1">
        <span
          className="font-eyebrow"
          style={{
            fontSize: 10,
            fontWeight: 800,
            letterSpacing: "0.2em",
            textTransform: "uppercase",
            color: "var(--hot-pink)",
          }}
        >
          ✦ Projects
        </span>
        <span
          className="font-eyebrow"
          style={{
            fontSize: 10,
            fontWeight: 700,
            color: "var(--plum)",
            opacity: 0.6,
          }}
        >
          {projects.length}
        </span>
      </div>

      <div className="flex flex-col gap-1.5 px-1">
        {projects.map((p) => (
          <ProjectRow key={p.id} project={p} hasActiveRun={activeProjectIds.has(p.name)} />
        ))}
      </div>

      <div className="mt-4">
        <TodayRailPane />
      </div>
      <div className="mt-3">
        <PrioritiesQueue />
      </div>
      <div className="mt-3">
        <ServicesMini />
      </div>
      <div className="mt-2">
        <ApprovalsQueue />
      </div>
      <div style={{ minHeight: 12 }} />
    </aside>
  );
}
